import { useState } from "react";

/**
 * Lightweight bulk-selection state for grid/list pages.
 * Used by PersonsPage + LogoLibraryPage to avoid duplicating the same
 * selectedIds / bulkMode / toggle logic.
 */
export function useBulkSelection() {
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [bulkMode, setBulkMode] = useState(false);

  const toggleSelect = (id) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const clearSelection = () => {
    setSelectedIds(new Set());
    setBulkMode(false);
  };

  const toggleBulkMode = () => {
    setBulkMode((prev) => {
      if (prev) setSelectedIds(new Set());
      return !prev;
    });
  };

  return {
    selectedIds,
    setSelectedIds,
    bulkMode,
    setBulkMode,
    toggleSelect,
    clearSelection,
    toggleBulkMode,
  };
}
